import { TypeFormation } from './group.types';

export enum SessionType {
  REGULAR = 'REGULAR',
  MAKEUP = 'MAKEUP',
  EXCEPTIONAL = 'EXCEPTIONAL',
}

export enum GradeStatus {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  CONTESTED = 'CONTESTED',
  FINAL = 'FINAL',
  NOT_ENTERED = 'NOT_ENTERED',
}

export enum CourseMaterialType {
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
  LINK = 'LINK',
  PRESENTATION = 'PRESENTATION',
  EXERCISE = 'EXERCISE',
  OTHER = 'OTHER',
}

export enum SubmissionStatus {
  SUBMITTED = 'SUBMITTED',
  GRADED = 'GRADED',
  RETURNED = 'RETURNED',
  LATE = 'LATE',
}

export enum AttendanceStatus {
  NOT_MARKED = 'NOT_MARKED',
  PRESENT = 'PRESENT',
  ABSENT_EXCUSED = 'ABSENT_EXCUSED',
  ABSENT_UNEXCUSED = 'ABSENT_UNEXCUSED',
  LATE = 'LATE',
}

// Professor Grade Report Types
export interface ProfessorCourseGradeStatus {
  professorId: string;
  professorName: string;
  staffCode: string;
  moduleElementId: string;
  moduleElementName: string;
  moduleCode: string;
  moduleName: string;
  filiereId: string;
  filiereCode: string;
  filiereName: string;
  groupeId: string;
  groupeName: string;
  niveau: number;
  typeFormation: TypeFormation;
  campusId?: string;
  campusName?: string;
  totalStudents: number;
  gradesEntered: number;
  gradesPending: number;
  percentageComplete: number;
  lastGradeEnteredAt?: string;
  // Course content counts
  announcementsCount: number;
  hasSyllabus: boolean;
  materialsCount: number;
  assignmentsCount: number;
  assignmentsWithSubmissions: number;
  attendanceRecorded: number;
  totalSessions: number;
}

export interface GradeStatistics {
  totalStudents: number;
  gradesEntered: number;
  gradesPending: number;
  averageGrade: number | null;
  minGrade: number | null;
  maxGrade: number | null;
  passRate: number | null;
  gradeDistribution: {
    range: string;
    count: number;
  }[];
}

export interface StudentGradeDetail {
  studentId: string;
  studentCode: string;
  firstName: string;
  lastName: string;
  groupeName: string;
  continuousAssessment: number | null;
  midtermExam: number | null;
  finalExam: number | null;
  practicalGrade: number | null;
  projectGrade: number | null;
  averageGrade: number | null;
  status: GradeStatus | string;
  comments: string | null;
  updatedAt: string | null;
}

// Course Content Types
export interface CourseAnnouncement {
  id: string;
  title: string;
  content: string;
  isPinned: boolean;
  createdAt: string;
}

export interface CourseSyllabus {
  id: string;
  objectives: string | null;
  content: string | null;
  evaluationMethod: string | null;
  bibliography: string | null;
  isPublished: boolean;
}

export interface CourseMaterial {
  id: string;
  title: string;
  description: string | null;
  fileUrl: string | null;
  materialType: CourseMaterialType;
  createdAt: string;
}

export interface CourseAssignment {
  id: string;
  title: string;
  description: string | null;
  dueDate: string;
  maxScore: number;
  isActive: boolean;
  submissionsCount: number;
  gradedCount: number;
}

export interface AttendanceSummary {
  totalSessions: number;
  recordedSessions: number;
  averageAttendanceRate: number | null;
}

export interface CourseContentDetail {
  announcements: CourseAnnouncement[];
  syllabus: CourseSyllabus | null;
  materials: CourseMaterial[];
  assignments: CourseAssignment[];
  attendanceSummary: AttendanceSummary;
  gradeStatistics: GradeStatistics;
}

// Filter Types
export interface GradesReportFilters {
  academicYears: { id: string; name: string; isCurrent: boolean }[];
  filieres: { id: string; code: string; name: string }[];
  niveaux: number[];
}

export interface GradesQueryParams {
  academicYearId?: string;
  filiereId?: string;
  groupeId?: string;
  niveau?: number;
  typeFormation?: TypeFormation;
  professorId?: string;
  search?: string;
}
